import * as yup from 'yup';
import _get from 'lodash/get';
import _map from 'lodash/map';
import _values from 'lodash/values';
import { RenderConfig, TextInput, DateRangeInput, SelectInput, Row } from 'commons-ui';

import {
	FORM_FIELD_KEYS,
	INVOICE_TYPE_OPTIONS,
	INVOICE_TYPE_LABLES,
	INVOICE_TYPE,
	GAME_NAMES,
	GAME_NAME_LABLES,
	GAME_NAME_OPTIONS
} from '../constants';

export const validationSchema = yup.object().shape({
	tournamentID: yup
		.string()
		.test('len', 'tournament ID length should be longer!', (val) => !val || val.length > 1)
		.optional(),
	userId: yup
		.string()
		.test('len', 'User ID length should be longer!', (val) => !val || val.length > 1)
		.optional()
});

export const FORM_FIELD_CONFIG = {
	[FORM_FIELD_KEYS.GAME_NAME]: new RenderConfig()
		.setName('gameName')
		.setLabel('Game Name')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_values(GAME_NAMES), (gameName) => ({
				id: _get(GAME_NAME_OPTIONS, gameName),
				label: _get(GAME_NAME_LABLES, gameName)
			}))
		}),
	[FORM_FIELD_KEYS.DATE_RANGE]: new RenderConfig()
		.setName('dateRange')
		.setLabel('Date Range')
		.setRenderer(DateRangeInput)
		.setRenderProps({
			placeholder: 'from-To date'
		}),
	[FORM_FIELD_KEYS.TOURNAMENT_ID]: new RenderConfig()
		.setName('tournamentID')
		.setLabel('Tournament ID')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.USER_ID]: new RenderConfig()
		.setName('userId')
		.setLabel('User ID')
		.setRenderer(TextInput)
		.setRenderProps({
			isEditable: { create: true, edit: true }
		}),
	[FORM_FIELD_KEYS.INVOICE_TYPE]: new RenderConfig()
		.setName('invoiceType')
		.setLabel('Invoice Type')
		.setRenderer(SelectInput)
		.setRenderProps({
			isEditable: { create: true, edit: true },
			required: true,
			options: _map(_values(INVOICE_TYPE), (invoiceType) => ({
				id: _get(INVOICE_TYPE_OPTIONS, invoiceType),
				label: _get(INVOICE_TYPE_LABLES, invoiceType)
			}))
		})
};

export const FORM_LAYOUT_CONFIG = [
	new Row(FORM_FIELD_KEYS.GAME_NAME),
	new Row(FORM_FIELD_KEYS.TOURNAMENT_ID),
	new Row(FORM_FIELD_KEYS.DATE_RANGE),
	new Row(FORM_FIELD_KEYS.INVOICE_TYPE),
	new Row(FORM_FIELD_KEYS.USER_ID)
];
